import { gql } from '@apollo/client'

import { SIMPLE_RESTOCK_GROUP_FRAGMENT } from '../fragments/SimpleRestockGroupFragment'

export const GET_TENANT_RESTOCK_GROUPS = gql`
  query GetTenantRestockGroups(
    $pagination: OffsetPaginationInput
    $filters: RestockGroupFilter
    $order: RestockGroupOrder
  ) {
    tenantRestockGroups(
      pagination: $pagination
      filters: $filters
      order: $order
    ) {
      results {
        ...SimpleRestockGroup
      }
      totalCount
    }
  }
  ${SIMPLE_RESTOCK_GROUP_FRAGMENT}
`
